import { useContext, useEffect, useState } from 'react';
import { currentDateForFile, firstDayMonth, YMD_FORMAT } from '../../utils/DateUtils';
import { AppContext } from '../../contexts/AppContext';
import moment from 'moment';
import SupplierExclusionCertificatesAPI from '../../services/SupplierExclusionCertificatesAPI';
import { decodeFileXLSX } from '../../utils/MiscellaneousUtils';

export const SORT = {
  UPWARD: 'upward',
  DOWNWARD: 'downward',
  NONE: '',
};

const useExcludedSupplierPresenter = tableRef => {
 
  const { showError, showWarning } = useContext(AppContext);
  const [firstLoad, setFirstLoad] = useState(true);
  const [loading, setLoading] = useState(false);

  const [rows, setRows] = useState([]);
  const [rowsToShow, setRowsToShow] = useState([]);
  const [sort, setSort] = useState('');
  const [oldSearchRequest, setOldSearchRequest] = useState({});
 
  const [open, setOpen] = useState(false);

  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [openExclusion, setOpenExclusion] = useState(false);

  const [openActivity, setOpenActivity] = useState(false);

  useEffect(() => {
    search();
  }, []);

  useEffect(() => {
    !openExclusion && !firstLoad && reloadGrid(true);
  }, [openExclusion])

  useEffect(() => {
    setRowsToShow(rows);
  }, [rows]);

  const cleanFilters = () => {

    setSelectedSupplier(null);
  };

  const search = reload => {
    /*
    const request = reload
      ? oldSearchRequest
      : {
          
          startDate: dateFrom ? dateFrom.format(YMD_FORMAT) : undefined,
          endDate: dateTo ? dateTo.format(YMD_FORMAT) : undefined,
          activityType: activityType ? activityType : undefined,
          user: user ? user : undefined,
          exclusionActivityType: 'Alta;Baja;Modificación'
          
        };
*/

    const request = reload ? oldSearchRequest : {
      SupplierCuit: selectedSupplier ? selectedSupplier.cuit : '',
    };
    setOldSearchRequest(request);

    firstLoad && setFirstLoad(false);
    setLoading(true);

    SupplierExclusionCertificatesAPI.getExcludedCertificate(request)
      .then(res => {
        setRows(res)
      })
      .catch(error => showError('Error al obtener los registros'))
      .finally(() => setLoading(false));
  };

  const reloadGrid = () => search(true);


  const validateAndSearch = () => search()//validateFilters() && search();


  return {

    selectedSupplier,
    setSelectedSupplier,
    openExclusion,
    setOpenExclusion,

    validateAndSearch,
    cleanFilters,
    rows,
    firstLoad,
    loading,
    gridFunctions: {
      disableSelectAll: 
      reloadGrid,
      open,
      setOpen,
      openExclusion,
      setOpenExclusion,

      openActivity,
      setOpenActivity,

      cuit: oldSearchRequest.cuit,
      gridActions: {
     
      },
    },
  };
};

export default useExcludedSupplierPresenter;